import { LocaleMessages } from 'vue-i18n'

const flpEnUsLocaleMessages: LocaleMessages = {
  holeriteSnapshot: {
    title: 'Pay Stub',
    pluralTitle: 'Pay Stubs of Group',
    typeTitle: 'Pay Stub ({type})',
    field: {
      tipoFolha: 'Type',
      periodo: 'Reference',
      numeroRecibo: 'Receipt',
      empregador: 'Employer',
      colaborador: 'Worker',
      vencimentos: 'Salaries',
      descontos: 'Discounts',
      totalVencimento: 'Total Salaries',
      totalDesconto: 'Total Discounts',
      valorLiquido: 'Net Value',
      detalhes: 'Details',
      salarioBase: 'Contractual Salary',
      baseCalculoIrrf: 'IRRF Calculation Basis',
      baseCalculoInss: 'INSS Calculation Basis',
      baseCalculoFgts: 'FGTS Calculation Basis',
      valorFgts: 'FGTS Value',
      observacoes: 'Remarks',
      checksum: 'Checksum',
      firstViewDatetime: 'Viewed at'
    },
    value: {
      tipoFolha: {
        FOLHA_NORMAL: 'Monthly',
        ADIANTAMENTO: 'Advance',
        DECIMO_TERCEIRO: '13th Salary',
        PARTICIPACAO_LUCROS: 'Profit Sharing',
        FOLHA_COMPLEMENTAR: 'Supplementary',
        DECIMO_TERCEIRO_COMPLEMENTAR: '13th Supplementary Salary'
      }
    }
  },
  holeriteSnapshotUserContext: {
    title: 'Pay Stub',
    pluralTitle: 'Pay Stubs'
  },
  informeRendimentoSnapshot: {
    title: 'Income Reporting',
    pluralTitle: 'Income Reportings of Group',
    yearTitle: 'Income Reporting {year}',
    field: {
      ano: 'Base Year',
      empregador: 'Employer',
      colaborador: 'Worker',
      naturezaRendimento: 'Nature of Income',
      numeroProcesso: 'Process Number',
      quantidadeMeses: 'Number of Months',
      grupos: 'Total Earnings',
      responsavel: 'Responsible',
      checksum: 'Checksum',
      firstViewDatetime: 'Viewed at'
    },
    value: {
      grupo: {
        1: '1 - PAYMENT SOURCE LEGAL OR PHYSICAL PERSON',
        2: '2 - INCOME BENEFICIAL PERSON',
        3: {
          0: '3 - TAXABLE INCOME, DEDUCTIONS AND INCOME TAX WITHDRAWN',
          1: '01 - Total earnings (including holidays)',
          2: '02 - Official social security contribution',
          3: '03 - Contribution to the private pension fund and the individual programmed retirement fund (FAPI)',
          4: '04 - Alimony (inform beneficiary in field 7)',
          5: '05 - Withholding income tax'
        },
        4: {
          0: '4 - EXEMPT AND NON-TAXABLE INCOME',
          1: '01 - Portion exempt from retirement, reserve, retirement and pension income (65 years and over)',
          2: '02 - Daily and per diem',
          3: '03 - Pension, retirement income or retirement due to serious illness and retirement or retirement by accident in service',
          4: '04 - Profit and dividend calculated from 1996 onwards by legal entity (actual, presumed or arbitrated profit)',
          5: '05 - Amounts paid to the holder or partner of micro and small enterprises, except pro-labore, rents',
          6: '06 - Indemnity for termination of employment, including POS and occupational accident',
          7: '07 - Others'
        },
        5: {
          0: '5 - INCOME SUBJECT TO EXCLUSIVE TAXATION (NET INCOME)',
          1: '01 - 13th salary',
          2: '02 - Withholding income tax on 13th salary',
          3: '03 - Others'
        },
        6: {
          0: '6 - INCOME RECEIVED ACCUMULATELY - Art. 12-A of Law No. 7,713 of 1988 (EXCLUSIVE TAX)',
          1: '01 - Total taxable income (including vacation and 13th salary)',
          2: '02 - Exclusion: Expenses with legal proceedings',
          3: '03 - Deduction: Official Social Security Contribution',
          4: '04 - Deduction: Alimony (see also Table 7)',
          5: '05 - Withholding income tax',
          6: '06 - Income exempt from pension, retirement income or retirement due to serious illness or retirement or retirement by accident in service'
        },
        7: '7 - ADDITIONAL INFORMATION',
        8: '8 - RESPONSIBLE FOR INFORMATION'
      }
    }
  },
  informeRendimentoSnapshotUserContext: {
    title: 'Income Reporting',
    pluralTitle: 'Income Reportings'
  },
  feriasSnapshot: {
    title: 'Vacation Notice',
    pluralTitle: 'Vacation Notices of Group',
    dateTitle: 'Vacation Notice ({date})',
    field: {
      periodoAquisitivo: 'Acquisition Period',
      periodoGozo: 'Vacation Period',
      periodoAbonoPecuniario: 'Pecuniary Allowance Period',
      periodoInicioFim: '{inicio} to {fim}',
      empregador: 'Employer',
      colaborador: 'Worker',
      normal: 'Normal',
      perdida: 'Lost',
      vencimentos: 'Salaries',
      descontos: 'Discounts',
      totalVencimento: 'Total Salaries',
      totalDesconto: 'Total Discounts',
      valorLiquido: 'Net Value',
      detalhes: 'Details',
      faltasDescontadas: 'Discounted Absences',
      salarioContratual: 'Contractual Salary',
      salarioBaseCalculo: 'Calculation Base Salary',
      salarioVariavelBaseCalculo: 'Calculation Base Variable Salary',
      baseCalculo: 'Vacation Calculation Basis',
      dataAviso: 'Notice Date',
      faltas: 'Absences',
      totalDiasAfastado: 'Days Leave',
      totalDiasFalta: 'Unjustified Absences',
      checksum: 'Checksum',
      firstViewDatetime: 'Viewed at'
    },
    description: {
      normal: 'According to article 135 of the CLT, the employer hereby notifies, with a minimum of 30 days in advance, that he will grant vacation in the vacation period informed below.',
      perdida: 'According to article 130 of the CLT, the employer hereby notifies the loss of the right to vacation in the acquisition period below.'
    }
  },
  feriasSnapshotUserContext: {
    title: 'Vacation Notice',
    pluralTitle: 'Vacation Notices'
  },
  empregador: {
    field: {
      razaoSocial: 'Company Name'
    },
    value: {
      tipoInscricao: {
        CPF: 'CPF',
        CNPJ: 'CNPJ'
      }
    }
  },
  colaborador: {
    field: {
      nome: 'Name',
      cbo: 'CBO',
      ctps: 'CTPS',
      pis: 'PIS',
      cpf: 'CPF',
      nascimento: 'Birth',
      admissao: 'Admission',
      local: 'Workplace',
      departamento: 'Department',
      setor: 'Sector',
      secao: 'Section'
    }
  }
}

export default flpEnUsLocaleMessages